class GraphCache {
    _memoryCache = {};

    memoryCache = {};

    static _instance = null;

    constructor() {
        const that = this;

        this.memoryCache = new Proxy(this._memoryCache, {
            get(target, p) {
                if (that._memoryCache[p]) {
                    return that._memoryCache[p];
                }

                return null;
            },
        });
    }

    static partialUpdate(id, data) {
        const cachedItem = GraphCache.get(id) || {};

        GraphCache.update(
            id,
            {
                ...cachedItem,
                ...data,
            },
        );
    }

    static update(id, data) {
        GraphCache.instance.memoryCache[id] = data;
    }

    static get(id) {
        return GraphCache.instance.memoryCache[id];
    }

    static getAllModelItems(modelName) {
        return Object.fromEntries(
            Object.entries(GraphCache.instance.memoryCache)
                .filter(([id]) => id.startsWith(`${modelName}:`)),
        );
    }

    static get instance() {
        if (!GraphCache._instance) {
            GraphCache._instance = new GraphCache();
        }

        return GraphCache._instance;
    }
}

export default GraphCache;
